export default __webpack_public_path__ + "static/media/Redtape.339555d5.png";